import PropTypes from 'prop-types'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Checkbox } from '../../../common/html/checkbox'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { PopupAction } from '../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../common/scrollComponent'
import { debounce } from '../../../helpers/common'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../../helpers/EventEmitter'
import { MAX_SIZE_COMPANY } from '../../constant'
import { TYPE_POPUP_MOVE_COPY } from '../../savedPortfolios/detailsPortfolios/constant'
import { CreatePortfolio } from '../../savedPortfolios/portfoliosOverview/components/CreatePortfolio'
import {
  selectDataRawTable,
  selectIsLoadingTableSavedPortfolio,
} from '../../savedPortfolios/portfoliosOverview/store/slice/slice'
import { getSearchPortfolio } from '../../savedPortfolios/portfoliosOverview/store/thunk'
import { Input } from '../html/input'

const styleDisable = {
  opacity: 0.6,
  borderBottom: '1px solid #D5D5D5',
}

export const PopupCopyOrMoveCompany = ({
  isShow,
  setShow,
  type,
  handleApply,
  numberCompany,
}) => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataRawTable)
  const loadingSearch = useSelector(selectIsLoadingTableSavedPortfolio)

  const [listCheck, setListCheck] = useState([])
  const [textSearch, setTextSearch] = useState('')
  const [isShowCreateForm, setIsShowCreateForm] = useState(false)

  const textValidate = UseI18n('library.main.VALIDATE_COMPANY')

  const height = useMemo(
    () => (data.length < 14 ? 36 * data.length : 400),
    [data.length],
  )

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        getSearchPortfolio({
          InputSearch: value,
          Page: 1,
          PageSize: 300,
        }),
      )
    }, 700),
    [],
  )

  const handleAfterCreate = () => {
    dispatch(
      getSearchPortfolio({
        InputSearch: '',
        Page: 1,
        PageSize: 300,
      }),
    )
    setTextSearch('')
  }

  const showErrorMaxSize = () => {
    EventEmitter.dispatch(SHOW_POPUP_ERROR, {
      messages: [textValidate],
    })
  }

  useEffect(() => {
    handleChangeText(textSearch)
  }, [textSearch])

  return (
    <>
      {isShow && (
        <PopupAction
          isShow={isShow}
          title={
            type !== TYPE_POPUP_MOVE_COPY.COPY
              ? 'library.detailsPortfolios.TEXT_MOVE_TO_PORTFOLIO'
              : 'library.detailsPortfolios.TEXT_COPY_TO_PORTFOLIO'
          }
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'library.filterSetting.APPLY',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              handleApply(listCheck)
            },
            disabled: !listCheck?.length,
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              setShow(false)
            },
          }}
        >
          <div>
            <div
              style={{ paddingBottom: 12 }}
              className="dFlex cursorPointer alignItemsCenter"
            >
              <Input
                containerStyle={{
                  flex: 1,
                  height: '28px',
                }}
                placeHolder="library.savePortfolio.SEARCH_PORTFOLIO"
                type="text"
                isSearch
                value={textSearch}
                onChange={setTextSearch}
              />
              <Element
                elementName="p"
                style={{ color: '#2C73E8', paddingLeft: 12 }}
                onClick={() => setIsShowCreateForm(true)}
              >
                <Translate value="library.savePortfolio.CREATE_NEW_PORTFOLIO" />
              </Element>
            </div>
            {(!!data.length || loadingSearch) && (
              <Element
                style={{
                  height: height,
                  backgroundColor: '#FFFFFF',
                  position: 'relative',
                }}
              >
                {loadingSearch ? (
                  <Loading />
                ) : (
                  <ScrollComponent>
                    <div
                      style={{
                        padding: '10px 12px',
                      }}
                    >
                      {data.map((item) => (
                        <ItemCheckBox
                          key={item.portfolioId}
                          item={item}
                          setListCheck={setListCheck}
                          listCheck={listCheck}
                          showError={showErrorMaxSize}
                          numberCompany={numberCompany}
                        />
                      ))}
                    </div>
                  </ScrollComponent>
                )}
              </Element>
            )}
          </div>
        </PopupAction>
      )}
      {isShowCreateForm && (
        <CreatePortfolio
          isShow={isShowCreateForm}
          setShow={setIsShowCreateForm}
          isChangeFragment={false}
          handleAfterCreate={handleAfterCreate}
        />
      )}
    </>
  )
}

const ItemCheckBox = ({
  item,
  setListCheck,
  listCheck,
  showError,
  numberCompany,
}) => {
  const isMaxSize = item?.numberOfCompany + numberCompany > MAX_SIZE_COMPANY
  return (
    <Element
      className={['dFlex alignItemsCenter gap1'].join(' ')}
      style={
        !isMaxSize
          ? { borderBottom: '1px solid #D5D5D5', cursor: 'pointer' }
          : styleDisable
      }
    >
      <Checkbox
        title={item?.portfolioName}
        checked={listCheck.includes(item.portfolioId)}
        onChange={() => {
          if (isMaxSize) {
            return showError()
          }
          setListCheck((prevList) => {
            if ([...prevList].includes(item.portfolioId)) {
              return prevList.filter((key) => key !== item.portfolioId)
            }
            return [...prevList, item.portfolioId]
          })
        }}
        isCheckOnClickText
        styleIcon={{ fontSize: 15, paddingRight: 8 }}
        style={{
          padding: '6px 0',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: 390,
        }}
      />
    </Element>
  )
}

PopupCopyOrMoveCompany.propTypes = {
  isShow: PropTypes.bool,
  setShow: PropTypes.func,
  type: PropTypes.string,
  handleApply: PropTypes.func,
  numberCompany: PropTypes.number,
}

PopupCopyOrMoveCompany.defaultProps = {
  numberCompany: 0,
}
